import React from "react";
import constants from "../../constants";
import { Controller } from 'react-hook-form';
import { setOpen } from "../../Actions/CountryPicker.action";
import { useSelector, useDispatch } from "react-redux";
import { translate } from "../../Services/translation";

function CountryField({ label, name, control, readOnly = false }) {
    const countryPickerActive = useSelector((state) => state.countryPicker.active);

    const dispatch = useDispatch();

    const deliveryAddressCountries = constants.deliveryAddressCountries;

    const countries = constants.countries.filter(x => {
        if(deliveryAddressCountries.length > 0){
            return deliveryAddressCountries.includes(x.value);
        }

        return true;
    });

    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <div>
                    {
                        label && <label htmlFor=""
                                        className="checkout__label">{label}</label>
                    }

                    <select className={"checkout__input " + (error ? "checkout__input--error" : "")}
                            onChange={onChange}
                            value={value}
                            disabled={readOnly}
                    >
                        <option value="" selected disabled hidden>Select country</option>
                        {
                            countries.map(x => {
                                return (<option value={x.value}>{x.text}</option>);
                            })
                        }
                    </select>

                    {error &&
                        <p className="checkout__input-validation-error">{error.message}</p>}

                    {
                        (!readOnly && countryPickerActive) &&
                        <button className="checkout__country-picker-button"
                                type="button"
                                onClick={(event) => {event.preventDefault(); dispatch(setOpen(true))}}>{translate("checkout.form.changecountry")}</button>
                    }
                </div>
            )}
        />
    )
}

export default CountryField;
